import { NgModule } from "@angular/core";
import { TieredMenuModule } from "primeng/tieredmenu";
import { TooltipModule } from "primeng/tooltip";
import { ButtonModule } from "primeng/button";
import { MultiSelectModule } from "primeng/multiselect";
import { SelectModule } from "primeng/select";
import { ToggleButtonModule } from "primeng/togglebutton";
import { DatePickerModule } from 'primeng/datepicker';
import { BreadcrumbModule } from 'primeng/breadcrumb';
import { ContextMenuModule } from "primeng/contextmenu";
import { AutoCompleteModule } from "primeng/autocomplete";
import { DatePicker } from "primeng/datepicker";
import { InputMaskModule } from "primeng/inputmask";

@NgModule({
  imports: [
    ToggleButtonModule,
    SelectModule,
    MultiSelectModule,
    ButtonModule,
    TieredMenuModule,
    TooltipModule,
    // TODO: Added for using UILibComponents in local. Remove when migrated
    DatePickerModule,
    BreadcrumbModule,
    ContextMenuModule,
    AutoCompleteModule,
    DatePicker,
    InputMaskModule,
  ],
  providers: [],
  exports: [
    ToggleButtonModule,
    SelectModule,
    MultiSelectModule,
    ButtonModule,
    TieredMenuModule,
    TooltipModule,
    // TODO: Added for using UILibComponents in local. Remove when migrated
    DatePickerModule,
    BreadcrumbModule,
    ContextMenuModule,
    AutoCompleteModule,
    DatePicker,
    InputMaskModule,
  ],
})
export class PrimeNgModule { }
